import React, { Component } from "react"
import DataHeader from "./containers/DataHeader"
import HistoryTable from "./containers/HistoryTable"
import DataTable from "./containers/DataTable"
import dataIcon from "app/styles/images/sp/data-selected.svg"
import { observer, Provider } from "mobx-react"
import arrayPgtDataManageDetail from "app/stores/arrayPgt/dataManageDetail"

@observer
export default class Index extends Component {
  constructor(props) {
    super(props)
    this.arrayPgtDataManageDetail = new arrayPgtDataManageDetail()
    this.arrayPgtDataManageDetail.setFamilyId(props.match.params.id)
  }

  componentWillUnmount() {
    this.arrayPgtDataManageDetail.clearState()
  }

  render() {
    return (
      <Provider arrayPgtDataManageDetail={this.arrayPgtDataManageDetail}>
        <div className="datamanage-detail-page pgd ">
          <h2 className="page-title">
            <img alt="" src={dataIcon} />
            数据管理 > 数据详情
          </h2>
          <div className="clearfix wrapper-box-first">
            <DataHeader />
          </div>
          <div>
            <DataTable />
            <HistoryTable />
          </div>
        </div>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/data_manage_detail/index.js